<!-- 旧件回收订单详情页 -->
<template>
  <div class="app-container order-detail-wrap">
    <div class="module-wrap">
      <el-descriptions title="基础信息" class="common-description-border">
        <el-descriptions-item label="订单编号">{{ formData.orderNo || '--' }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">{{ changeStatus(formData) }}</el-descriptions-item>
        <el-descriptions-item label="网点编号">{{ formData.networkNo || '--' }}</el-descriptions-item>
        <el-descriptions-item label="网点名称">{{ formData.networkName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="回收数量">{{ formData.recoveryNum || '--' }}</el-descriptions-item>
        <el-descriptions-item label="承运商">{{ formData.carrierName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">
          {{ formData.createdDate | formatDateTimeDefault('', '--') }}
        </el-descriptions-item>
        <el-descriptions-item label="期望预约时间">
          {{ formData.expectStartDate | formatDateTimeDefault('', '--') }} ~
          {{ formData.expectEndDate | formatDateTimeDefault('', '--') }}
        </el-descriptions-item>

        <el-descriptions-item label="回收地址"
          >{{ (formData.province || '') + (formData.city || '') + (formData.county || '') + (formData.detailAddress || '') }}
          <span v-if="formData.detailAddress">
            <img v-if="!dataVisible.detailAddress" src="@/assets/eye-close.png" @click="toggleVisibility('detailAddress')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('detailAddress')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="归集仓">{{ formData.warehouseName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="归集仓地址">
          {{ formData.wareHouseAddress || '--' }}
          <span v-if="formData.wareHouseAddress">
            <img v-if="!dataVisible.wareHouseAddress" src="@/assets/eye-close.png" @click="toggleVisibility('wareHouseAddress')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('wareHouseAddress')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="所属区域">
          {{ formData.regionName || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="联系人">
          {{ formData.contact || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="联系电话">
          {{ formData.tel || '--' }}
          <span v-if="formData.tel">
            <img v-if="!dataVisible.telPhone" src="@/assets/eye-close.png" @click="toggleVisibility('telPhone')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('telPhone')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="备用联系电话">
          {{ formData.spareTel || '--' }}
          <span v-if="formData.spareTel">
            <img v-if="!dataVisible.spareTelPhone" src="@/assets/eye-close.png" @click="toggleVisibility('spareTelPhone')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('spareTelPhone')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="归集仓联系人">
          {{ formData.warehouseContact || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="归集仓联系电话">
          {{ formData.warehouseTel || '--' }}
          <span v-if="formData.warehouseTel">
            <img v-if="!dataVisible.warehouseTelPhone" src="@/assets/eye-close.png" @click="toggleVisibility('warehouseTelPhone')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('warehouseTelPhone')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="城市等级">
          {{ formData.cityLevel || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="是否按时履约">
          {{ formData.requiredFlag }}
        </el-descriptions-item>
        <el-descriptions-item label="超时统计">
          {{ formData.timeOutDay || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="挂起次数">
          {{ formData.hangupCount || 0 }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="module-wrap">
      <!-- 回收人员就是回收师傅 -->
      <el-descriptions title="派工信息" class="common-description-border">
        <el-descriptions-item label="回收人员姓名">{{ formData.recoveryWorkerName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="回收人员电话"
          >{{ formData.workerTel || '--' }}
          <span v-if="formData.workerTel">
            <img v-if="!dataVisible.workerTelPhone" src="@/assets/eye-close.png" @click="toggleVisibility('workerTelPhone')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('workerTelPhone')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="上门车牌号">{{ formData.doorVehicleLicenseNo || '--' }}</el-descriptions-item>
        <el-descriptions-item label="预约时间"
          >{{ formData.appointStartDate | formatDateTimeDefault('', '--') }} ~ {{ formData.appointEndDate | formatDateTimeDefault('', '--') }}</el-descriptions-item
        >
        <el-descriptions-item label="派工时间">{{ formData.dispatchDate | formatDateTimeDefault('', '--') }}</el-descriptions-item>
        <el-descriptions-item label="操作预约时间">{{ formData.operrateAppointDate }}</el-descriptions-item>
        <el-descriptions-item label="订单完成时间">{{ formData.completeDate | formatDateTimeDefault('', '--') }}</el-descriptions-item>
        <el-descriptions-item label="回收完成时间">{{ formData.recoveryCompleteDate | formatDateTimeDefault('', '--') }}</el-descriptions-item>
        <el-descriptions-item label="异常信息反馈">{{ formData.feedback || '--' }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="module-wrap">
      <el-descriptions title="回收信息" class="common-description-border">
        <el-descriptions-item label="签到时间">{{ formData.workerCheckDate | formatDateTimeDefault('', '--') }}</el-descriptions-item>
        <el-descriptions-item label="签到地址"
          >{{ formData.workerCheckAddress || '--' }}
          <span v-if="formData.workerCheckAddress">
            <img v-if="!dataVisible.workerCheckAddress" src="@/assets/eye-close.png" @click="toggleVisibility('workerCheckAddress')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('workerCheckAddress')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="实收数量">{{ formData.actualCollectionNum || '--' }}</el-descriptions-item>
        <el-descriptions-item label="送货人姓名">{{ formData.driverName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="送货人电话"
          >{{ formData.driverTel || '--' }}
          <span v-if="formData.driverTel">
            <img v-if="!dataVisible.driverTelPhone" src="@/assets/eye-close.png" @click="toggleVisibility('driverTelPhone')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('driverTelPhone')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="送货人车牌号">{{ formData.vehicleLicenseNo || '--' }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ formData.remark || '--' }}</el-descriptions-item>
        <el-descriptions-item label="客户出库单">
          {{ formData.outboundNo || '--' }}
        </el-descriptions-item>
        <el-descriptions-item label="出库照片">
          <template v-if="formData.outBoundPhoto">
            <div class="downLoadLink" v-if="isPDF(formData.outBoundPhoto)" @click="downLoadPdf(formData.outBoundPhoto)">
              {{ formData.outBoundPhoto }}
            </div>
            <image-upload
              v-else
              :imageUrl.sync="formData.outBoundPhoto"
              :editMode="partnershipType == 1 || partnershipType == 3"
              @success="uploadSuccess($event, 'outBoundPhoto')"
            />
          </template>
          <span v-else>--</span>
        </el-descriptions-item>
        <el-descriptions-item label="装车照片">
          <image-upload
            v-if="formData.loadTruckPhoto"
            :imageUrl.sync="formData.loadTruckPhoto"
            :editMode="partnershipType == 1 || partnershipType == 3"
            @success="uploadSuccess($event, 'loadTruckPhoto')"
          />
          <span v-else>--</span>

          <!-- <el-image
            class="image-style"
            fit="cover"
            v-show="formData.loadTruckPhoto !== null"
            :src="formatImgUrl(formData.loadTruckPhoto)"
            :preview-src-list="[formatImgUrl(formData.loadTruckPhoto)]"
          ></el-image>
          <template v-if="!formData.loadTruckPhoto">--</template> -->
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="module-wrap">
      <div class="sub-title">回收明细 线上</div>
      <div class="table">
        <el-table :data="formData.onLineDetailList">
          <el-table-column prop="recycleCode" label="回收码"></el-table-column>
          <el-table-column prop="oldInternalBarcode" label="内机条码"></el-table-column>
          <el-table-column prop="oldExternalBarcode" label="外机条码"></el-table-column>
          <el-table-column prop="specification" label="网点鉴定旧机规格">
            <template slot-scope="scope">
              {{ formatOldType(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="copperPipeAmount" label="网点鉴定连接管">
            <template slot-scope="scope">
              {{ scope.row.copperPipeAmount == '1' ? '有' : '无' }}
            </template>
          </el-table-column>
          <el-table-column prop="appraisalSpecification" label="回收人员鉴定旧机规格">
            <template slot-scope="scope" v-if="[5, 6, 7].includes(formData.status)">
              {{ formatAppraisalOldType(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="copperTubeLength" label="回收人员鉴定铜管长度">
            <template slot-scope="scope">
              {{ scope.row.copperTubeLength }}
            </template>
          </el-table-column>
          <el-table-column prop="aluminumTubeLength" label="回收人员鉴定铝管长度">
            <template slot-scope="scope">
              {{ scope.row.aluminumTubeLength }}
            </template>
          </el-table-column>
          <el-table-column label="回收人员鉴定完整度">
            <template slot-scope="scope" v-if="[5, 6, 7].includes(formData.status)">
              {{ formatAppraisalNodeEnumsMap(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="price" label="旧机价值(网点鉴定)"></el-table-column>
          <el-table-column prop="appraisalPrice" label="旧机价值(回收人员鉴定)"></el-table-column>
        </el-table>
      </div>
      <div class="sub-title">回收明细 线下</div>
      <div class="table">
        <el-table :data="formData.offLineDetailList">
          <el-table-column prop="recycleCode" label="回收码"></el-table-column>
          <el-table-column prop="oldInternalBarcode" label="内机条码"></el-table-column>
          <el-table-column prop="oldExternalBarcode" label="外机条码"></el-table-column>
          <el-table-column prop="specification" label="网点鉴定旧机规格">
            <template slot-scope="scope">
              {{ formatOldType(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="copperPipeAmount" label="网点鉴定连接管">
            <template slot-scope="scope">
              {{ scope.row.copperPipeAmount == '1' ? '有' : '无' }}
            </template>
          </el-table-column>
          <el-table-column prop="appraisalSpecification" label="回收人员鉴定旧机规格">
            <template slot-scope="scope" v-if="[5, 6, 7].includes(formData.status)">
              {{ formatAppraisalOldType(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="copperTubeLength" label="回收人员鉴定铜管长度">
            <template slot-scope="scope">
              {{ scope.row.copperTubeLength }}
            </template>
          </el-table-column>
          <el-table-column prop="aluminumTubeLength" label="回收人员鉴定铝管长度">
            <template slot-scope="scope">
              {{ scope.row.aluminumTubeLength }}
            </template>
          </el-table-column>
          <el-table-column label="回收人员鉴定完整度" width="200">
            <template slot-scope="scope" v-if="[5, 6, 7].includes(formData.status)">
              {{ formatAppraisalNodeEnumsMap(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="price" label="旧机价值(网点鉴定)"></el-table-column>
          <el-table-column prop="appraisalPrice" label="旧机价值(回收人员鉴定)"></el-table-column>
        </el-table>
      </div>
      <div class="sub-title">回收汇总 线上</div>
      <div class="table">
        <el-table :data="formData.onLineList">
          <el-table-column type="brand" label="旧机名称" width="150">
            <template slot-scope="scope">
              {{ scope.row.oldMachineInfo }}
            </template>
          </el-table-column>
          <el-table-column prop="makeOrderNum" label="下单数量" width="150"></el-table-column>
          <el-table-column prop="actualCollectionNum" label="实收数量" width="150"></el-table-column>
          <el-table-column prop="copperPipeAmount" label="下单连接管数量" width="150"></el-table-column>
          <el-table-column prop="copperTubeLength" label="实收铜管长度" width="150"></el-table-column>
          <el-table-column prop="aluminumTubeLength" label="实收铝管长度" width="150"></el-table-column>
          <el-table-column prop="actualBigValve" label="大阀门" width="150"></el-table-column>
          <el-table-column prop="actualSmallValve" label="小阀门" width="150"></el-table-column>
          <el-table-column prop="actualExElectricalMachinery" label="外机电机" width="150"></el-table-column>
          <el-table-column prop="actualInElectricalMachinery" label="内机电机" width="150"></el-table-column>
          <el-table-column prop="actualExWindBlade" label="外机风叶" width="150"></el-table-column>
          <el-table-column prop="actualInWindBlade" label="内机风叶" width="150"></el-table-column>
          <el-table-column prop="actualInternalPanel" label="内机面板" width="150"></el-table-column>
          <el-table-column prop="actualExCover" label="外机外罩" width="150"></el-table-column>
          <el-table-column prop="actualExBoard" label="外机顶板/底板" width="150"></el-table-column>
          <el-table-column prop="actualPowerLine" label="电源线" width="150"></el-table-column>

          <el-table-column prop="price" label="旧机价值"></el-table-column>
        </el-table>
      </div>
      <div class="sub-title">回收汇总 线下</div>
      <div class="table">
        <el-table :data="formData.offLineList">
          <el-table-column type="brand" label="旧机名称" width="150">
            <template slot-scope="scope">
              {{ scope.row.oldMachineInfo }}
            </template>
          </el-table-column>
          <el-table-column prop="makeOrderNum" label="下单数量" width="150"></el-table-column>
          <el-table-column prop="actualCollectionNum" label="实收数量" width="150"></el-table-column>
          <el-table-column prop="copperPipeAmount" label="下单连接管数量" width="150"></el-table-column>
          <el-table-column prop="copperTubeLength" label="实收铜管长度" width="150"></el-table-column>
          <el-table-column prop="aluminumTubeLength" label="实收铝管长度" width="150"></el-table-column>
          <el-table-column prop="actualBigValve" label="大阀门" width="150"></el-table-column>
          <el-table-column prop="actualSmallValve" label="小阀门" width="150"></el-table-column>
          <el-table-column prop="actualExElectricalMachinery" label="外机电机" width="150"></el-table-column>
          <el-table-column prop="actualInElectricalMachinery" label="内机电机" width="150"></el-table-column>
          <el-table-column prop="actualExWindBlade" label="外机风叶" width="150"></el-table-column>
          <el-table-column prop="actualInWindBlade" label="内机风叶" width="150"></el-table-column>
          <el-table-column prop="actualInternalPanel" label="内机面板" width="150"></el-table-column>
          <el-table-column prop="actualExCover" label="外机外罩" width="150"></el-table-column>
          <el-table-column prop="actualExBoard" label="外机顶板/底板" width="150"></el-table-column>
          <el-table-column prop="actualPowerLine" label="电源线" width="150"></el-table-column>

          <el-table-column prop="price" width="160" label="旧机价值(下单)"></el-table-column>
        </el-table>
      </div>
      <div class="total-price">旧机价值总额: {{ formData.bondAmount || '--' }}元</div>
      <div class="total-price">扣款金额: {{ formData.deductionAmount || 0 }}元</div>
      <div class="total-price">扣款原因: {{ formData.deductionReason || '--' }}</div>

      <div class="total-price">挂机/外机重量: {{ formData.totalExWeight || '--' }}</div>
      <div class="total-price">柜内机重量: {{ formData.totalInWeight || '--' }}</div>
      <div class="total-price">铜管重量: {{ formData.totalCopperTubeWeight || '--' }}</div>
    </div>
  </div>
</template>
<script>
import { getRecoveryOrderByOrderNo, updateOldMachineRecovery } from '@/api/oldForNew'
import { orderStatusOption, recyclingStatusOption } from './mixin.js'
import imageUpload from '@/components/Upload/ImageUpload'

export default {
  name: 'orderDetail',
  components: { imageUpload },
  computed: {
    baseUrl() {
      return process.env.BASE_API
    }
  },
  data() {
    return {
      orderNo: this.$route.query.orderNo,
      formData: {
        status: '1',
        outBoundPhoto: '', //出库
        loadTruckPhoto: ''
      }, //回收详情对象
      productImageBase64: '',
      orderStatusOption: orderStatusOption, //订单状态
      recyclingStatusOption,
      partnershipType: '', // 1: "子公司", 2: "合作商", 3: "总公司" ,
      driverTelPhone: '',
      telPhone: '',
      spareTelPhone: '',
      workerTelPhone: '',
      warehouseTelPhone: '',
      detailAddress: '',
      originData: '',
      workerCheckAddress: '',
      wareHouseAddress: '',
      dataVisible: {
        driverTelPhone: false,
        telPhone: false,
        spareTelPhone: false,
        workerTelPhone: false,
        warehouseTelPhone: false,
        detailAddress: false,
        workerCheckAddress: false,
        wareHouseAddress: false
      }
    }
  },
  filters: {},
  async created() {
    this.partnershipType = JSON.parse(localStorage.getItem('partnershipType'))
    if (this.orderNo) {
      this.getDetail()
    }
  },
  methods: {
    formatImgUrl(value) {
      return this.baseUrl + `/autoapp-default-server-recovery/api/OSS/generatePresignedUrl?objectName=${value}`
    },
    changeStatus(value) {
      if (!value.status) {
        return ''
      }

      const statusLabel = this.getOptionLabel(this.orderStatusOption, value.status)
      if (!statusLabel) {
        return ''
      }

      if (value.recyclingStatus && value.status === 4) {
        const recyclingStatusLabel = this.getOptionLabel(this.recyclingStatusOption, value.recyclingStatus)
        if (recyclingStatusLabel) {
          return `${statusLabel} - ${recyclingStatusLabel}`
        }
      }

      return statusLabel
    },
    getOptionLabel(options, value) {
      const option = options.find(item => item.value == value)
      return option ? option.label : ''
    },
    //获取回收详情
    async getDetail() {
      let { statusCode, data, message } = await getRecoveryOrderByOrderNo(this.orderNo)

      if (statusCode == 200) {
        this.formData = data
        this.originData = data ? { ...data } : {}

        // 根据 sensitizationCode 拆分数据
        if (data.desensitizationDtoList && Array.isArray(data.desensitizationDtoList)) {
          const phoneMappings = {
            driverTel_phone: 'driverTelPhone',
            tel_phone: 'telPhone',
            spareTel_phone: 'spareTelPhone',
            workerTel_phone: 'workerTelPhone',
            warehouseTel_phone: 'warehouseTelPhone',
            detailAddress_address: 'detailAddress',
            workerCheckAddress_address: 'workerCheckAddress',
            wareHouseAddress_address: 'wareHouseAddress'
          }

          data.desensitizationDtoList.forEach(item => {
            const targetProperty = phoneMappings[item.sensitizationCode]
            if (targetProperty) {
              this[targetProperty] = {
                sensitizationCode: item.sensitizationCode,
                message: item.message
              }
            }
          })
        }
      } else {
        this.$message.error(message)
      }
    },
    async uploadSuccess(val, flag) {
      this.formData[flag] = val
      const param = {
        orderNo: this.formData.orderNo,
        outBoundPhoto: flag === 'outBoundPhoto' ? val : undefined,
        loadTruckPhoto: flag === 'loadTruckPhoto' ? val : undefined
      }
      const { statusCode } = await updateOldMachineRecovery(param)
      if (statusCode == 200) {
        this.$message.success('更新图片成功')
      }
    },

    // 大阀门-有;小阀门-有;外机风叶-有;内机风叶-有;外机电机-有;内机电机-有;内机面板-无;外机外罩-有;外机顶板/底板-无;无电源线-无;铝管-无
    formatAppraisalNodeEnumsMap(row) {
      return `大阀门-${row.actualBigValve ? '有' : '无'}； 小阀门-${row.actualSmallValve ? '有' : '无'}； 外机风叶-${row.actualExWindBlade ? '有' : '无'}； 内机风叶-${
        row.actualInWindBlade ? '有' : '无'
      }； 外机电机-${row.actualExElectricalMachinery ? '有' : '无'}； 内机电机-${row.actualInElectricalMachinery ? '有' : '无'}； 内机面板-${
        row.actualInternalPanel ? '有' : '无'
      }； 外机外罩-${row.actualExCover ? '有' : '无'}； 外机顶板/底板-${row.actualExBoard ? '有' : '无'}； 电源线-${row.actualPowerLine ? '有' : '无'}`
    },
    //网点旧机规格格式化
    formatOldType({ brand, specification, model }) {
      return (brand ? brand : '') + (specification ? specification : '') + (model ? model : '')
    },
    //回收人员旧机规格格式化

    formatAppraisalOldType({ appraisalBrand, appraisalSpecification, appraisalModel }) {
      return (
        (appraisalBrand ? (appraisalBrand == 'GREE' ? '格力' : '非格力') : '') + (appraisalSpecification ? appraisalSpecification : '') + (appraisalModel ? appraisalModel : '')
      )
    },
    isPDF(url) {
      return url.endsWith('.pdf')
    },
    downLoadPdf(url) {
      const pdfUrl = process.env.BASE_API + `/autoapp-default-server-recovery/api/OSS/generatePresignedUrl?objectName=${url}`

      window.open(pdfUrl, '_blank')
    },

    getSourceOrigin(data) {
      return this.HttpService.post(`/autoapp-default-server-recovery/api/deSensitization/getSource`, data).then(res => {
        if (res.statusCode === 200) {
          return res.data
        }
      })
    },
    toggleVisibility(dataType) {
      // 切换显示状态
      this.dataVisible[dataType] = !this.dataVisible[dataType]

      // 根据不同类型处理显示逻辑
      switch (dataType) {
        case 'driverTelPhone':
          if (this.dataVisible.driverTelPhone && this.driverTelPhone.message) {
            this.getSourceOrigin(this.driverTelPhone).then(res => {
              this.$set(this.formData, 'driverTel', res)
            })
          } else if (!this.dataVisible.driverTelPhone) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'driverTel', this.originData.driverTel)
          }
          break
        case 'telPhone':
          if (this.dataVisible.telPhone && this.telPhone.message) {
            this.getSourceOrigin(this.telPhone).then(res => {
              this.$set(this.formData, 'tel', res)
            })
          } else if (!this.dataVisible.telPhone) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'tel', this.originData.tel)
          }
          break
        case 'spareTelPhone':
          if (this.dataVisible.spareTelPhone && this.spareTelPhone.message) {
            this.getSourceOrigin(this.spareTelPhone).then(res => {
              this.$set(this.formData, 'spareTel', res)
            })
          } else if (!this.dataVisible.spareTelPhone) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'spareTel', this.originData.spareTel)
          }
          break
        case 'workerTelPhone':
          if (this.dataVisible.workerTelPhone && this.workerTelPhone.message) {
            this.getSourceOrigin(this.workerTelPhone).then(res => {
              this.$set(this.formData, 'workerTel', res)
            })
          } else if (!this.dataVisible.workerTelPhone) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'workerTel', this.originData.workerTel)
          }
          break
        case 'warehouseTelPhone':
          if (this.dataVisible.warehouseTelPhone && this.warehouseTelPhone.message) {
            this.getSourceOrigin(this.warehouseTelPhone).then(res => {
              this.$set(this.formData, 'warehouseTel', res)
            })
          } else if (!this.dataVisible.warehouseTelPhone) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'warehouseTel', this.originData.warehouseTel)
          }
          break
        case 'detailAddress':
          if (this.dataVisible.detailAddress && this.detailAddress.message) {
            this.getSourceOrigin(this.detailAddress).then(res => {
              this.$set(this.formData, 'detailAddress', res)
            })
          } else if (!this.dataVisible.detailAddress) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'detailAddress', this.originData.detailAddress)
          }
          break
        case 'workerCheckAddress':
          if (this.dataVisible.workerCheckAddress && this.workerCheckAddress.message) {
            this.getSourceOrigin(this.workerCheckAddress).then(res => {
              this.$set(this.formData, 'workerCheckAddress', res)
            })
          } else if (!this.dataVisible.workerCheckAddress) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'workerCheckAddress', this.originData.workerCheckAddress)
          }
          break
        case 'wareHouseAddress':
          if (this.dataVisible.wareHouseAddress && this.wareHouseAddress.message) {
            this.getSourceOrigin(this.wareHouseAddress).then(res => {
              this.$set(this.formData, 'wareHouseAddress', res)
            })
          } else if (!this.dataVisible.wareHouseAddress) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'wareHouseAddress', this.originData.wareHouseAddress)
          }
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.order-detail-wrap {
  .module-wrap {
    margin-bottom: 10px;
  }
  .sub-title {
    font-size: 16px;
    font-weight: bold;
    color: rgb(48, 49, 51);
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .image-style {
    width: 80px;
    height: 80px;
    margin-right: 20px;
  }
  .total-price {
    font-size: 12px;
    color: #606266;
    margin-top: 10px;
  }
  .footer-wrap {
    display: flex;
    justify-content: flex-end;
  }
  .downLoadLink {
    color: #1459c0;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/orderDetail.vue